import { TextField } from '@mui/material';

type TaxNumberInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
};

export function TaxNumberInput({ value, onChange }: TaxNumberInputProps) {
  return (
    <TextField
      type='text'
      label='Steuernummer'
      size='small'
      value={value || ''}
      onChange={event =>
        onChange(event.target.value !== '' ? event.target.value : null)
      }
      fullWidth
    />
  );
}
